import { ReferralJoinSuccessContentFragment } from '@/models/cms';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Routes } from '@/router';
import { RewardsPageLoadEvent } from '@/services/analytics/events/rewards-page-load-event';

@Component({
  name: 'CmgReferralJoinSuccessModal',
})
export default class CmgReferralJoinSuccessModal extends Vue {
  content: ReferralJoinSuccessContentFragment = {};

  get isRewardsReferralProgramEnabled(): boolean {
    return this.$appStore.state.featureFlags.featureFlags.isRewardsReferralProgramEnabled;
  }

  @Watch('isRewardsReferralProgramEnabled')
  async onRewardsReferralProgramEnabledChange(newValue: boolean) {
    if (newValue) {
      await this.$services.config.setReferralJoinSuccessModal();
      this.content = this.$services.config.getReferralJoinSuccessModal() || {};
    }
  }

  @Watch('visible')
  async onVisibleChange(newValue: boolean) {
    if (newValue) {
      this.$services.analytics.applyOne({
          account: {
              rewardsEnroll: { value: 1 }
          }
      })
      this.$services.analytics.send(new RewardsPageLoadEvent('referral:welcome-to-rewards'));
    }
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.referralJoinSuccessModal.visible;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  async mounted() {
    this.$services.ui.firstFocus();
  }

  get title(): string {
    return this.content.title || 'WELCOME TO REWARDS';
  }

  get subtitle(): string {
    return this.content.subtitle || 'Enjoy Your Free Guacamole, on us';
  }

  get bodyText(): string {
    return this.content.bodyText || '<p>You\'re all set! We\'ve added your free guacamole to your Rewards account. Place your first order over $10 to earn an extra 100 points. Start enjoying your perks today!&nbsp;</p>';
  }

  get primaryCta(): string {
    return this.content.primaryCta || 'CONTINUE TO REWARDS!';
  }

  get guacImageUrl(): string {
    return this.$appStore.state.cms.images.menu.guac.default;
  }

  get starPolygonUrl(): string {
    return this.$appStore.state.cms.images.icons.starPolygon.default;
  }

  get lottieBackgroundSparklesUrl(): string {
    return this.$appStore.state.cms.animations.bag.lottieBackgroundSparklesUrl;
  }

  get rewardsCount() {
    return this.$appStore.state.customer.wallet.promotions.length;
  }

  onClickCta() {
    this.$router.push({ name: Routes.Rewards });
    this.onClose();
  }

  onClose() {
    try {
      if (!this.rewardsCount) {
        this.$services.promotions.refreshCustomerPromotions();
      }
    } catch (err: any) {
      this.$services.logger.error('Something went wrong while fetching customer promotions: ', err);
    }

    this.$services.ui.setModalVisibility('referralJoinSuccessModal', false);
  }
}
